import { ProductModel } from './product.model';
export class UserWizardProductModel {
    product: ProductModel[];
}
